import * as tslib_1 from "tslib";
import { createSelector } from '@ngrx/store';
import * as userPreference from 'store/actions/user-preference.actions';
import { TablePreferenceType } from 'modules/shared/models/table-preference.models';
var initialState = {
    tablesPreference: {}
};
export function reducer(state, action) {
    var _a, _b, _c, _d;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case userPreference.UserPreferenceActionTypes.SET_PAGINATION_PREFERENCE: {
            return tslib_1.__assign({}, state, { tablesPreference: tslib_1.__assign({}, state.tablesPreference, (_a = {}, _a[action.payload.tableName] = tslib_1.__assign({}, state.tablesPreference[action.payload.tableName], (_b = {}, _b[TablePreferenceType.PAGE_SIZE] = action.payload.pageSize, _b)), _a)) });
        }
        case userPreference.UserPreferenceActionTypes.SET_SORT_PREFERENCE: {
            return tslib_1.__assign({}, state, { tablesPreference: tslib_1.__assign({}, state.tablesPreference, (_c = {}, _c[action.payload.tableName] = tslib_1.__assign({}, state.tablesPreference[action.payload.tableName], (_d = {}, _d[TablePreferenceType.SORT] = action.payload.sort, _d)), _c)) });
        }
        default: {
            return state;
        }
    }
}
var userPreferenceSelector = function (state) { return state.userPreference; };
var ɵ0 = userPreferenceSelector;
var ɵ1 = function (state) { return state.tablesPreference; };
export var Selectors = {
    getTablesPreference: createSelector(userPreferenceSelector, ɵ1),
};
export { ɵ0, ɵ1 };
